import React from 'react';
import './OurTeam.css';


const OurTeam = () => {
  // Sample team data - replace with your actual data source
  const teamData = [
    {
      id: 1,
      name: " ⁠Mr. Ashok Kumar",
      role: "(Founder & Managing Director)",
      image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=300&h=300&fit=crop&crop=face"
    },
    {
      id: 2,
      name: "⁠CA. Puneet Zaroo",
      role: "(Chief Strategist – Direct & Indirect Taxes & Assurance)",
      image: "/assets/images/c3.png"
    },
    {
      id: 3,
      name: "Ms. Raman Passicha",
      role: "(CEO & Director - Operations)",
      image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=300&h=300&fit=crop&crop=face"
    },
    {
      id: 4,
      name: "Mrs. Archana Passicha",
      role: "(CPO & Director - Recruitment & HR Operations)",
      image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=300&h=300&fit=crop&crop=face"
    },
    {
      id: 5,
      name: "Dr. (Mrs.) Prairna Z. Kalia",
      role: "(Social Awareness & CSR Initiatives)",
      image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=300&h=300&fit=crop&crop=face"
    },
    {
      id: 6,
      name: "Mrs. Sneha Wangnoo",
      role: "Consultant – System & Cyber Security",
      image: "https://images.unsplash.com/photo-1556157382-4e063bb26661?w=300&h=300&fit=crop&crop=face"
    },
    {
      id: 7,
      name: "Ms. Kusum Mishra",
      role: "Secretarial Lead",
      image: "/assets/images/c4.png"
    },
     {
      id: 8,
      name: "Ms. Harpreet Kaur",
      role: "Legal Head",
      image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=300&h=300&fit=crop&crop=face"
    },
    {
      id: 9,
      name: "Mr. Suroy Singh",
      role: "Transaction Advisory & Account Structuring",
      image: "https://images.unsplash.com/photo-1556157382-4e063bb26661?w=300&h=300&fit=crop&crop=face"
    },
    {
      id: 10,
      name: "CA Hitesh Babu",
      role: "Consultant – Audit & Assurance",
      image: "/assets/images/c4.png"
    }
  ];

  // If you want to use your original data source, uncomment this line:
  // const data = JSON.parse(localStorage.getItem('siteData')) || require('../../siteData.json');

  return (
    <div className="our-team-section">
      <div className="container">
        <div className="team-header">
          <h2 className="section-title1">OUR TEAM OF PROFESSIONAL</h2>
          <p>Our strength lies in our multidisciplinary team of experienced professionals.</p>
        </div>

        <div className="team-grid">
          {teamData.map((member) => (
            <div key={member.id} className="team-card">
              <div className="team-image-container">
                <img src={member.image} alt={member.name} className="team-image" />
              </div>
              <div className="team-info">
                <h3 className="team-name">{member.name}</h3>
                <h2 className="team-role">{member.role}</h2>
              </div>
            </div>
          ))}
        </div>

        <div className="pagination">
        </div>
        
      </div>
    </div>
    
  );
};

export default OurTeam;